import React from 'react';
import { Grid } from '@mui/material';
import { ComputerArt } from '../3DArt.js';

export function ComputerArtPage() {
  return (
    <Grid container spacing={1}>
      <ComputerArt />
    </Grid>
  );
}
